/*
 * @Author: liuyixie
 * @Date: 2022-10-10 15:10:43
 * @LastEditors: CZH
 * @LastEditTime: 2022-10-31 17:44:31
 * @Description: file content
 */
/* eslint-disable standard/no-callback-literal */
const validUtils = {
  required (_field) {
    return {
      required: true,
      validator: (rule, value, callback) => {
        if (value === null || value === undefined || (typeof value === 'string' && !value.trim())) {
          callback(`【${_field}】不能为空！`);
        } else {
          callback();
        }
      },
      trigger: ['blur', 'change']
    };
  },
  // 数组检测-不能为空
  arrayRequire (_field) {
    return {
      required: true,
      validator: (rule, value, callback) => {
        if (!value || value.length === 0) {
          callback(`【${_field}】不能为空！`);
        } else {
          callback();
        }
      },
      trigger: ['blur', 'change']
    };
  },
  // 正数，大于0的数
  positiveNumber (_field, _integerNum, _decimalNum) {
    const reg = '^(?!(0[0-9]{0,}$))[0-9]{1,}[.]{0,}[0-9]{0,}$';
    return {
      pattern: new RegExp(reg),
      message: `【${_field}】应为大于0的数字！`,
      trigger: ['blur', 'change']
    };
  },
  // 最大值校验
  maxNumberValid (_field) {
    const max = 2147483647;
    return {
      validator: (rule, value, callback) => {
        if (Number(value) <= max) {
          callback();
        }
        callback(new Error(`【${_field}】不能超过${max}`));
      },
      trigger: ['blur', 'change']
    };
  },
  // 最大值校验
  maxLengthValid (_field, maxLength) {
    return {
      validator: (rule, value, callback) => {
        if (!value || value.length > maxLength) {
          callback(new Error(`【${_field}】长度不能超出${maxLength}位！`));
        } else {
          callback();
        }
      },
      trigger: ['blur', 'change']
    };
  },
  // 手机号码/固定电话检验
  phone (_field) {
    const reg = /^((0\d{2,3}(-)?\d{7,8})|(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8})$/;
    return {
      validator: (rule, value, callback) => {
        if (reg.test(value)) {
          callback();
        }
        callback(new Error(`【${_field}】格式不正确`));
      },
      trigger: ['blur', 'change']
    };
  }

};
export default validUtils;
